import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';

import { loadJournalTags } from '../../../../../state/modules/journalTags/actions';
import TagInput from '../components/TagInput';
import { loadJournalPartnerTags } from '../../../../../state/modules/journalPartnerTags/actions';

const defaultLimit = 20;
const defaultOrder = 'is_default.asc';

const mapStateToProps = (state, ownProps) => {
  const limit = 500;
  const order = null;

  // merge results for all modules (journalTags)
  const results = [].concat.apply(
    [],
    Object.entries(
      state.journalTags.getIn(['pages', defaultOrder, defaultLimit], {})
    ).map(([k, v]) => v.toArray())
  );

  // merge results for all pages (journalPartnerTags)
  const results_partner = [].concat.apply(
    [],
    Object.entries(
      state.journalPartnerTags.getIn(['pages', order, limit], {})
    ).map(([k, v]) => v.toArray())
  );

  const tags = state.entities.get('journalTags', {});
  const partner_tags = state.entities.get('journalPartnerTags', {});

  const list =
    results.length > 0
      ? results.map((x) => {
          return {
            ...denormalize(
              state.entities.getIn(['journalTags', x]),
              schema.journalTag,
              state.entities.toJS()
            ),
            isPartnerTag: false,
          };
        })
      : [];

  const list_partner =
    results_partner.length > 0
      ? results_partner.map((x) => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['journalPartnerTags', x]),
              schema.journalPartnerTag,
              state.entities.toJS()
            ),
            isPartnerTag: true,
          };
        })
      : [];

  // Combine and sort alphabetically by label
  const combinedList = [...list, ...list_partner].sort((a, b) => {
    const labelA = (a.label || '').toLowerCase();
    const labelB = (b.label || '').toLowerCase();
    return labelA.localeCompare(labelB);
  });

  return {
    list: list,
    list_partner: list_partner,
    combinedList: combinedList,
    options: Object.keys(tags).map((id) => {
      return { label: tags[id].label, value: id };
    }),
    options_partner: Object.keys(partner_tags).map((id) => {
      return { label: partner_tags[id].label, value: id };
    }),
    isLoading: state.journalTags.get('isLoading'),
    isLoadingPartnerTags: state.journalPartnerTags.get('isLoading'),
    activeId: state.careGuides.get('activeId'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (
      page = 1,
      limit = defaultLimit,
      order = defaultOrder,
      filter = {},
      cb = function () {}
    ) => {
      dispatch(
        loadJournalTags(page, limit, order, filter, (success, total) => {
          if (success) {
            // loop over all pages to get all events
            const pageCount = Math.ceil(total / limit);
            for (var i = 2; i <= pageCount; i++) {
              dispatch(loadJournalTags(i, limit, order, filter));
            }
            cb();
          }
        })
      );
    },
    loadPartnerTags: (
      care_guide_id,
      page = 1,
      limit = 500,
      order = null,
      filter = {},
      cb = function () {}
    ) => {
      dispatch(
        loadJournalPartnerTags(
          care_guide_id,
          page,
          limit,
          order,
          filter,
          (success, total) => {
            if (success) {
              // loop over all pages to get all partner tags
              const pageCount = Math.ceil(total / limit);
              for (var i = 2; i <= pageCount; i++) {
                dispatch(
                  loadJournalPartnerTags(care_guide_id, i, limit, order, filter)
                );
              }
              cb();
            }
          }
        )
      );
    },
  };
};

const TagInputContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TagInput);

export default TagInputContainer;
